import { Controller } from "@hotwired/stimulus"

// The "Members are in Good Company" section on the membership landing page.
// The markup is the animation's end state (headline + chart), so it is what a
// visitor sees without JavaScript, with reduced motion, or on a phone. Otherwise
// the section is armed in its opening state — the scattered portraits, never
// blank — and plays once, the first time it scrolls into view. It is CSS
// transitions only: nothing listens to scroll, so it never holds scrolling up.
export default class extends Controller {
  connect() {
    if (!this.shouldAnimate()) return

    this.element.classList.add("is-armed")
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.play()
    }, { threshold: 0.3 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  play() {
    this.observer?.disconnect()
    this.observer = null

    this.element.classList.add("has-motion")
    // Two frames, so the armed styles are painted before they transition away.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.element.classList.remove("is-armed"))
    })
  }

  shouldAnimate() {
    if (!("IntersectionObserver" in window)) return false
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false

    return !window.matchMedia("(max-width: 767.98px)").matches
  }
}
